"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Fragment;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Fragment(params) {
  return new _fragment(params);
}

var _fragment = exports._fragment = function _fragment(params) {
  _classCallCheck(this, _fragment);

  this.name = params.name;
  this.type = params.type;
  this.fields = params.fields;
  this.fragments = params.fragments;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZyYWdtZW50LmpzIl0sIm5hbWVzIjpbIkZyYWdtZW50IiwicGFyYW1zIiwiX2ZyYWdtZW50IiwibmFtZSIsInR5cGUiLCJmaWVsZHMiLCJmcmFnbWVudHMiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUF3QkEsUTs7OztBQUFULFNBQVNBLFFBQVQsQ0FBa0JDLE1BQWxCLEVBQTBCO0FBQ3ZDLFNBQU8sSUFBSUMsU0FBSixDQUFjRCxNQUFkLENBQVA7QUFDRDs7SUFFWUMsUyxXQUFBQSxTLEdBQ1gsbUJBQVlELE1BQVosRUFBb0I7QUFBQTs7QUFDbEIsT0FBS0UsSUFBTCxHQUFZRixPQUFPRSxJQUFuQjtBQUNBLE9BQUtDLElBQUwsR0FBWUgsT0FBT0csSUFBbkI7QUFDQSxPQUFLQyxNQUFMLEdBQWNKLE9BQU9JLE1BQXJCO0FBQ0EsT0FBS0MsU0FBTCxHQUFpQkwsT0FBT0ssU0FBeEI7QUFDRCxDIiwiZmlsZSI6ImZyYWdtZW50LmpzIiwic291cmNlUm9vdCI6Ii9Vc2Vycy90aGFuaXNoL0dpdGh1Yi9tbm10YW5pc2gvZ3JhcGhxbGlmeS9zcmMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBGcmFnbWVudChwYXJhbXMpIHtcbiAgcmV0dXJuIG5ldyBfZnJhZ21lbnQocGFyYW1zKTtcbn1cblxuZXhwb3J0IGNsYXNzIF9mcmFnbWVudCB7XG4gIGNvbnN0cnVjdG9yKHBhcmFtcykge1xuICAgIHRoaXMubmFtZSA9IHBhcmFtcy5uYW1lO1xuICAgIHRoaXMudHlwZSA9IHBhcmFtcy50eXBlO1xuICAgIHRoaXMuZmllbGRzID0gcGFyYW1zLmZpZWxkcztcbiAgICB0aGlzLmZyYWdtZW50cyA9IHBhcmFtcy5mcmFnbWVudHM7XG4gIH1cbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../node_modules/graphqlify/lib/fragment.js
// module id = 648
// module chunks = 46 47